export function removeHttp(inputSrc: any) {
  let src = inputSrc;
  if (!src) return src;

  if (typeof src === 'object' && src.backgroundImage) {
    src.backgroundImage = src.backgroundImage.replace('p.qpic.cn', 'puep.qpic.cn');
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '');
    return src;
  }
  src = src.replace('p.qpic.cn', 'puep.qpic.cn');

  return src.replace(/^http(s?):/, '');
}
